var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/components/adicionales/list/adicionales.html';
var html = "<ui-crud-view datatable-options=vm.options report-options=vm.reportOptions icon-classes=\"glyph-icon icon-plus-square-o\" goto-form=vm.gotoForm() goto-form-permissions=create_marcas> <ui-crud-header> <h2>{{ 'Administración de adicionales' | translate }}</h2> </ui-crud-header> <ui-crud-title>{{ 'Listado de adicionales' | translate }}</ui-crud-title> <ui-crud-body> <ui-datatable options=vm.options></ui-datatable> </ui-crud-body> </ui-crud-view>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/components/adicionales/list/adicionales.html
// module id = 1128
// module chunks = 0